<!-- app-subdomain-creators/src/accountPages/ChatPageCreator.vue -->

<template>

  <!-- Incoming Call Modal -->
  <MemberChatVideoCallMeetingIncoming
    v-if="!isCallActive"
    v-model:open="incomingCallModalOpen"
    @start-call="handleStartCall"
  />

  

  <!-- Outer Flex Container -->
  <div class="flex w-full h-[calc(100vh-170px)] items-stretch gap-4">

    <!-- Left Member List sidebar -->
    <div class="w-[20%] min-w-[240px] h-full overflow-hidden ">
      <CreatorChatMemberListComponent
        @select-member="handleSelectMember"
        @select-channel="handleSelectChannel"
      />
    </div>

    <!-- Creator Main Chat Area (Center) -->
    <section class="flex-1 h-full flex flex-col items-stretch px-4">

      <!-- header -->
      <div
        class="max-w-5xl mx-auto w-full sm:px-5 py-2 flex flex-row justify-between items-center border-t border-l border-r rounded-t-lg relative"
      >
<!-- Member profile + single status indicator -->
<div
  class="mb-3 md:mb-0 order-1 md:order-1 flex items-center cursor-pointer gap-2"
  v-if="activeMember"
>

<!-- Avatar with single status dot -->
<div class="relative inline-block">
  <img
    :src="activeMember?.avatar || defaultAvatar"
    :alt="activeMember ? (activeMember.profileName || activeMember.name || 'Member Avatar') : 'Member Avatar'"
    class="w-12 h-12 rounded-full border-4 border-white object-cover"
    @error="handleActiveMemberAvatarError"
  />

  <!-- Status dot -->
  <div
    class="absolute bottom-0 right-0.5 w-4 h-4 rounded-full border-2 border-white"
    :class="{
      'bg-green-500': activeMemberStatus === 'online',
      'bg-yellow-500': activeMemberStatus === 'away',
      'bg-gray-300': activeMemberStatus === 'offline'
    }"
  ></div>
</div>


  <!-- Name + text status + time -->
  <div>
    <h2
      class="text-[12px] mt-2 sm:mt-auto font-semibold text-[#676d77] sm:text-[12px] lg:text-[16px] xl:text-[16px] mx-auto leading-5"
    >
      {{ activeMember ? (activeMember.profileName || activeMember.name || 'Selected member') : 'Select a member' }}
    </h2>

    <div class="flex gap-2 items-center">
      <!-- Single status label -->
      <h2
        class="text-[10px] font-normal sm:text-[10px] lg:text-[14px] xl:text-[14px] leading-5"
        :class="activeMemberStatusColorClass"
      >
        {{ activeMemberStatusLabel }}
      </h2>

      <div class="bg-[#98a0af] rounded-full w-1 h-1"></div>

      <h2
        class="text-[10px] font-normal text-[#676d77] sm:text-[10px] lg:text-[14px] xl:text-[14px] leading-5"
      >
        {{ currentTime }}
      </h2>
    </div>
  </div>
</div>


      <!-- creator online profile/status -->
      <div
        v-if="!isSearchVisible"
     

        :class="[
    'z-40 absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2',
    activeMember ? 'sm:top-20 top-10' : 'sm:top-40 top-10'
  ]"
      >
        <!-- Pseudo border with blur effect -->
        <div
          class="absolute -inset-2 !rounded-full bg-green-500 blur opacity-70 animate-pulse"
          style="filter: blur(6px)"
        ></div>

        <!-- Hidden file input for chat feature avatar -->
        <input
          ref="chatAvatarInput"
          type="file"
          accept="image/jpeg,image/png,image/gif"
          class="hidden"
          @change="handleChatAvatarChange"
        />

               <!-- Adjusted Avatar Image (click to change) -->
        <div
          class="relative w-24 h-24 md:w-32 md:h-32 cursor-pointer group"
          @click="triggerChatAvatarFile"
          @mouseenter="showAvatarTooltip = true"
          @mouseleave="showAvatarTooltip = false"
        >
          <!-- Avatar image -->
          <img
            :src="chatAvatarSrc"
            alt="Creator Chat Avatar"
            class="w-full h-full !rounded-full object-cover"
            style="border-radius: 50% !important"
          />

          <!-- Dark overlay with camera + text on hover -->
          <div
            v-if="showAvatarTooltip"
            class="absolute inset-0 bg-black bg-opacity-60 rounded-full flex flex-col items-center justify-center text-white text-[11px] md:text-xs text-center pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-out"
          >
            <CameraIcon class="w-9 h-9 mb-1 opacity-60" />
            <span class="text-xs">Choose a .png or .jpeg image</span>
          </div>

          <!-- Tooltip (same style as Search Chat tooltip: left of avatar, arrow on right) -->
          <div
            v-if="showAvatarTooltip"
            class="absolute text-center w-40 bottom-full p-2 -translate-x-48 -mb-16 bg-black opacity-60 text-white text-sm rounded tooltip"
          >
            Change the Avatar for this chat
            <div
              class="tooltip-arrow absolute top-1/2 -right-1 mt-[-5px] w-0 h-0 border-l-[12px] border-transparent border-b-[12px] transform -translate-y-1/2 rotate-45 rounded bg-black"
            ></div>
          </div>
        </div>
      </div>



        <!-- search and video call icons/buttons -->
        <div v-if="activeMember" class="order-3 md:order-3 flex gap-2 items-center sm:justify-end">
          <!-- Search Chat -->
          <div class="relative">
            <MagnifyingGlassIcon
              v-if="!isSearchVisible"
              @click="toggleSearchOverlay"
              @mouseenter="showSearchChatTooltip = true"
              @mouseleave="showSearchChatTooltip = false"
              class="w-6 text-zinc-400 font-bold cursor-pointer"
            ></MagnifyingGlassIcon>

            <XMarkIcon
              v-if="isSearchVisible"
              @click="toggleSearchOverlay"
              @mouseenter="showSearchCloseChatTooltip = true"
              @mouseleave="showSearchCloseChatTooltip = false"
              class="w-6 h-6 text-zinc-400 hover:text-[#2D8CFF] font-bold cursor-pointer"
            ></XMarkIcon>

            <!-- Search Chat tooltip -->
            <div
              v-if="showSearchChatTooltip && !isSearchVisible"
              class="absolute text-center w-28 bottom-full p-2 -translate-x-32 -mb-8 bg-black opacity-60 text-white text-sm rounded tooltip"
            >
              Search Chat
              <div
                class="tooltip-arrow absolute top-1/2 -right-1 mt-[-5px] w-0 h-0 border-l-[12px] border-transparent border-b-[12px] transform -translate-y-1/2 rotate-45 rounded bg-black"
              ></div>
            </div>

           <!-- Search Chat tooltip -->
            <div
              v-if="showSearchCloseChatTooltip && isSearchVisible"
              class="absolute text-center w-28 bottom-full p-2 -translate-x-32 -mb-8 bg-black opacity-60 text-white text-sm rounded tooltip"
            >
              Close Search
              <div
                class="tooltip-arrow absolute top-1/2 -right-1 mt-[-5px] w-0 h-0 border-l-[12px] border-transparent border-b-[12px] transform -translate-y-1/2 rotate-45 rounded bg-black"
              ></div>
            </div>



          </div>

          <!-- ✅ Conversation Status Controls -->
          <CreatorChatConversationStatus
            :member="activeMember"
            :feature-instance-id="selectedChannel?.id"
            @update-member="applyConversationPatch"
          />


          <!-- Video Meeting Call -->
          <div class="relative">
            <!-- <img
              @mouseenter="showVideoCallTooltip = true"
              @mouseleave="showVideoCallTooltip = false"
              src="@/assets/media/images/video-call-chat-icon.svg"
              alt="video call platforma meetings"
              class="w-12 h-12 rounded-full border-4 border-white cursor-pointer"
              @click="openVideoCallModal"
            /> -->

            <!-- <MemberChatVideoCallMeeting
              v-if="isCallActive"
              v-model:open="videoCallModalOpen"
              @close-modal="closeVideoCallModal"
            /> -->

            <!-- Video Meeting Call tooltip -->
            <!-- <div
              v-if="showVideoCallTooltip"
              class="absolute text-center w-28 bottom-full p-2 -translate-x-28 -mb-12 bg-black opacity-60 text-white text-sm rounded tooltip"
            >
              Video Meeting Call
              <div
                class="tooltip-arrow absolute top-1/2 -right-1 mt-[-5px] w-0 h-0 border-l-[12px] border-transparent border-b-[12px] transform -translate-y-1/2 rotate-45 rounded bg-black"
              ></div>
            </div> -->
          </div>


        </div>
      </div>

      <!-- message area -->
      <div class="flex-1 flex flex-col justify-between overflow-hidden">
        <!-- <div
          class=""
          
        > -->

        <div
            :class="[
              'sm:border-r sm:border-l sm:border-b rounded-b-lg  md:p-6 flex flex-col flex-1 overflow-hidden mx-auto scrollbar-thin overflow-y-auto w-full',
              activeMember ? 'border-t ' : 'border-t-0'
            ]"
          >
          <CreatorChatMainComponent
            :member="activeMember"
            :open="isOpen"
            :showSearch="isSearchVisible"
            @toggleSearch="toggleSearchOverlay"
            :feature-instance-id="selectedChannel?.id"
            :feature-avatar-url="selectedChannel?.raw?.feature_avatar_url"
            @member-typing="handleMemberTypingStatus"  
          />
        </div>
      </div>
    </section>

    <!-- Right Member Profile sidebar -->
    <div class="w-[20%] min-w-[240px] h-full overflow-hidden">
      <CreatorChatMemberProfileComponent
        :member="activeMember"
      />
    </div>

  </div>

</template>


<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue';
import CreatorChatMainComponent from '@/Components/CreatorChatMainComponent.vue';
// import MemberChatVideoCallMeeting from '@/Components/MemberChatVideoCallMeeting.vue';
import MemberChatVideoCallMeetingIncoming from '@/Components/MemberChatVideoCallMeetingIncoming.vue';
import CreatorChatMemberListComponent from '@/Components/CreatorChatMemberListComponent.vue';
import CreatorChatMemberProfileComponent from '@/Components/CreatorChatMemberProfileComponent.vue';
import CreatorChatConversationStatus from '@/Components/CreatorChatConversationStatus.vue'
import { usePresenceStore } from '@/stores/presenceStore';
import { useWebsocketStore } from '@/stores/websocketStore';



import {
  XMarkIcon,
  MagnifyingGlassIcon,
  CameraIcon,
} from '@heroicons/vue/24/outline';

import defaultAvatar from '@/assets/media/images/default-avatar.png';

const apiProxyUrl = process.env.VUE_APP_API_PROXY_URL;

const activeMember = ref(null)
const selectedChannel = ref(null);
const websocketStore = useWebsocketStore();  // 🔥
const presenceStore = usePresenceStore();    // 🔥

// Avatar hover tooltip
const showAvatarTooltip = ref(false);

function handleActiveMemberAvatarError(event) {
  const img = event?.target
  if (!img) return
  img.src = defaultAvatar
}

function getMemberPresenceId(member) {
  if (!member) return null;
  return (
    member.user_id || // DB-style
    member.userId ||  // sometimes camelCased
    member.id ||      // generic
    null
  );
}

function handleSelectMember(member) {
  activeMember.value = member || null
}


function handleSelectChannel(channel) {
  console.log('[ChatPageCreator] selected channel:', channel);
  selectedChannel.value = channel;

  // 🔥 prevent loading old member convo under new featureInstanceId
  activeMember.value = null;
}


function handleMemberTypingStatus(isTyping) {
  if (!activeMember.value) return;
  // this object is the SAME reference as in CreatorChatMemberListComponent
  activeMember.value.isTyping = isTyping;
}

function applyConversationPatch({ patch }) {
  // activeMember is the SAME object reference from the list, so this updates both places
  if (!activeMember.value || !patch) return
  Object.assign(activeMember.value, patch)
}


/* -------------------------
   Chat feature avatar logic
-------------------------- */

// file input ref
const chatAvatarInput = ref(null);

// compute current chat avatar source
const chatAvatarSrc = computed(() => {
  const raw = selectedChannel.value?.raw;
  // if backend returned feature_avatar_url, use it; otherwise default
  return raw?.feature_avatar_url || defaultAvatar;
});

// open OS file picker
const triggerChatAvatarFile = () => {
  if (!selectedChannel.value) {
    console.warn('[ChatPageCreator] No channel selected for chat avatar upload');
    return;
  }
  chatAvatarInput.value?.click();
};

const handleChatAvatarChange = (event) => {
  const file = event.target.files?.[0];
  if (!file) return;

  uploadChatAvatar(file);

  // reset input value so selecting the same file again still triggers change
  event.target.value = '';
};

const uploadChatAvatar = async (file) => {
  if (!file || !selectedChannel.value) return;

  try {
    const sanitizedFilename = encodeURIComponent(
      file.name.replace(/[^a-zA-Z0-9._-]/g, '_')
    );

    const payload = {
      filename: sanitizedFilename,
      contentType: file.type,
      imageType: 'chat_feature_avatar',      // 🔴 ties to backend logic
      featureInstanceId: selectedChannel.value.id, // instance_id on backend
    };

    // Step 1: get signed URL from backend via proxy
    const res = await fetch(`${apiProxyUrl}/api/uploads/generate-signed-url`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      console.error('Error getting signed URL for chat avatar:', err);
      throw new Error(err.message || 'Failed to fetch signed URL');
    }

    const { signedUrl, permanentUrl } = await res.json();

    // Step 2: upload the actual file to S3
    const uploadRes = await fetch(signedUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });

    if (!uploadRes.ok) {
      console.error('Error uploading chat avatar to S3:', await uploadRes.text());
      throw new Error('Error uploading image to the signed URL.');
    }

    // Step 3: update local selectedChannel so UI updates immediately
    if (selectedChannel.value.raw) {
      selectedChannel.value.raw.feature_avatar_url = permanentUrl;
    } else {
      selectedChannel.value = {
        ...selectedChannel.value,
        raw: { feature_avatar_url: permanentUrl },
      };
    }
  } catch (error) {
    console.error('Error uploading chat feature avatar:', error);
    alert('Error uploading chat avatar. Please try again.');
  }
};

// const isCreatorOnline = ref(false)

// const sideBarOPen = ref(false)

// Reactive reference to store current time
const currentTime = ref(new Date().toLocaleTimeString());
let intervalId;

const isOpen = ref(false); // or true based on initial state


// Video Call Tooltip
// const showVideoCallTooltip = ref(false);

// Search Chat Tooltip
const showSearchChatTooltip = ref(false);
const showSearchCloseChatTooltip = ref(false);

const isSearchVisible = ref(false);

const toggleSearchOverlay = () => {
  isSearchVisible.value = !isSearchVisible.value;

  // 🔒 Always hide tooltip when search overlay is toggled
  showSearchChatTooltip.value = false;
};


const isCallActive = ref(false); // Controls the call state
const incomingCallModalOpen = ref(false); // Controls the incoming call modal

// Log initial state of isCallActive
console.log('Initial isCallActive value:', isCallActive.value);

// Video call logic
// const videoCallModalOpen = computed({
//   get: () => isCallActive.value || false, // Ensure it's always Boolean
//   set: (val) => {
//     console.log('Setting videoCallModalOpen to:', val);
//     if (!val) {
//       console.log('Call is ending. Setting isCallActive to false.');
//       isCallActive.value = false;
//     }
//   }
// });


// const openVideoCallModal = () => {
//   console.log('Opening Video Call Modal');
//   handleStartCall(); // Start the call immediately
// };

// const closeVideoCallModal = () => {
//   console.log('Closing Video Call Modal');
//   isCallActive.value = false; // End the call
//   incomingCallModalOpen.value = false; // Ensure incoming call modal is closed
//   console.log('isCallActive after closing:', isCallActive.value);
// };



let incomingCallTimeout = null;

// // Open the incoming call modal after 5 seconds
// const scheduleIncomingCall = () => {
//   incomingCallTimeout = setTimeout(() => {
//     if (!isCallActive.value) {
//       incomingCallModalOpen.value = true;
//     }
//   }, 5000);
// };

// Cancel the scheduled incoming call
const cancelIncomingCall = () => {
  clearTimeout(incomingCallTimeout);
};



// Function to handle starting the call
const handleStartCall = () => {
  console.log('Starting the call. Setting isCallActive to true.');
  isCallActive.value = true; // Start the call
  incomingCallModalOpen.value = false; // Close the incoming call modal
  cancelIncomingCall(); // Cancel any scheduled incoming call
  console.log('isCallActive after starting the call:', isCallActive.value);
};

const activeMemberStatus = computed(() => {
  if (!activeMember.value) return 'offline';
  const memberId = getMemberPresenceId(activeMember.value);
  if (!memberId) return 'offline';
  return presenceStore.memberStatus(memberId); // 'online' | 'away' | 'offline'
});

const activeMemberStatusLabel = computed(() => {
  switch (activeMemberStatus.value) {
    case 'online':
      return 'Online';
    case 'away':
      return 'Away';
    default:
      return 'Offline';
  }
});

const activeMemberStatusColorClass = computed(() => {
  switch (activeMemberStatus.value) {
    case 'online':
      return 'text-green-600';
    case 'away':
      return 'text-yellow-500';
    default:
      return 'text-gray-400';
  }
});


watch(
  () => activeMember.value,
  (val) => {
    const memberId = getMemberPresenceId(val);
    if (!memberId) return;

    // 🔥 ask backend to subscribe this socket to this member's presence
    websocketStore.send({
      type: 'creator',
      event: 'presence:subscribeMembers',
      payload: {
        memberIds: [memberId],
      },
    });
  },
  { immediate: true }
);


// Update time every second
onMounted(() => {
  intervalId = setInterval(() => {
    currentTime.value = new Date().toLocaleTimeString();
  }, 1000);
});

onMounted(() => {
  // scheduleIncomingCall();
});


// If the component is unmounted, ensure that we clear the timeout.
onBeforeUnmount(() => {
  cancelIncomingCall();
});

// Clear the interval when the component is destroyed
onBeforeUnmount(() => {
  clearInterval(intervalId);
});

</script>

<style scoped>

/* Customize the scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1; /* Tailwind's zinc-400 */
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8; /* Tailwind's zinc-500 */
}

::-webkit-scrollbar-track {
  background: #f1f5f9; /* Tailwind's zinc-100 */
  border-radius: 4px;
}

.scrollbar-thin {
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #cbd5e1 #f1f5f9; /* thumb color, track color */
}

</style>

